import { Component, OnInit,OnChanges,Input } from '@angular/core';

@Component({
  selector: 'app-tpayment-steps-row',
  templateUrl: './tpayment-steps-row.component.html',
  styleUrls: ['./tpayment-steps-row.component.scss']
})
export class TpaymentStepsRowComponent implements OnInit,OnChanges {
  step1Active : boolean = true;
  step2Active : boolean = false;
  step3Active : boolean = false;
  step4Active : boolean = false;
  firstLineClass : string = "";
  secondLineClass : string = "";
  thirdLineClass : string = "";
  @Input() step : string;
  constructor() { }

  ngOnInit() {
    this.checkSteps();
  }

  ngOnChanges() {
    this.checkSteps();
  }

  checkSteps(){
    switch(this.step){
      case "1":
      this.selectStep1();
        break;
      case "2":
      this.selectStep2();
        break;
      case "3":
      this.selectStep3();
        break;
      case "4":
      this.selectStep4();
        break;
    }
  }

  selectStep1(){
    this.step1Active = true;
    this.step2Active = false;
    this.step3Active = false;
    this.step4Active = false;
    this.firstLineClass = "";
    this.secondLineClass = "";
    this.thirdLineClass = "";
  }
  selectStep2(){
    this.step1Active = true;
    this.step2Active = true;
    this.step3Active = false;
    this.step4Active = false;
    this.firstLineClass = "active-line";
    this.secondLineClass = "";
    this.thirdLineClass = "";
  }
  selectStep3(){
    this.step1Active = true;
    this.step2Active = true;
    this.step3Active = true;
    this.step4Active = false;
    this.firstLineClass = "active-line";
    this.secondLineClass = "active-line";
    this.thirdLineClass = "";
  }

  selectStep4(){
    this.step1Active = true;
    this.step2Active = true;
    this.step3Active = true;
    this.step4Active = true;
    this.firstLineClass = "active-line";
    this.secondLineClass = "active-line";
    this.thirdLineClass = "active-line";
  }


}
